export const formatPhoneNumber = (value) => {
  const inputPhone = value.slice(0, 15);
  const formattedPhone = inputPhone
    .replace(/\D/g, '') // remove anything that is not a digit
    .replace(/^(\d{2})(\d)/g, '($1) $2') // format area code
    .replace(/(\d)(\d{4})$/, '$1-$2'); // format last four digits
  return formattedPhone;
}
